import React, { useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import logo from "../../assets/logo2.png";
import "./Header.css";
import "./dropdown.css";

const Header = () => {
  const location = useLocation();
  const navbarRef = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);

  const isActive = (path) => location.pathname === path;
  const isServicesActive = () => location.pathname.startsWith("/services");

  const closeMobileMenu = () => {
    const navbar = navbarRef.current;
    if (!navbar) return;

    if (navbar.classList.contains("show")) {
      navbar.classList.remove("show");

      const toggler = navbar.parentElement?.querySelector(".navbar-toggler");
      if (toggler) {
        toggler.setAttribute("aria-expanded", "false");
        toggler.classList.add("collapsed");
      }
    }
  };

  const closeDropdown = (dropdownRef) => {
    const dropdown = dropdownRef?.current;
    if (!dropdown) return;

    const toggle = dropdown.querySelector(".dropdown-toggle");
    const menu = dropdown.querySelector(".dropdown-menu");

    dropdown.classList.add("dropdown-closing");
    dropdown.classList.remove("show");
    menu?.classList.remove("show");
    toggle?.classList.remove("show");
    toggle?.setAttribute("aria-expanded", "false");
    toggle?.blur();

    if (window.bootstrap?.Dropdown && toggle) {
      const instance = window.bootstrap.Dropdown.getOrCreateInstance(toggle);
      instance.hide();
    }

    window.setTimeout(() => {
      dropdown.classList.remove("dropdown-closing");
    }, 250);
  };

  const closeAllDropdowns = () => {
    closeDropdown(servicesRef);
    closeDropdown(aboutRef);
  };

  const handleNavClick = (dropdownRef = null) => {
    closeMobileMenu();

    if (dropdownRef) {
      closeDropdown(dropdownRef);
    } else {
      closeAllDropdowns();
    }
  };

  useEffect(() => {
    closeMobileMenu();
    closeAllDropdowns();
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SiteNavigationElement",
            name: [
              "Home",
              "About Us",
              "IVF Services",
              "Contact",
              "Book Appointment"
            ],
            url: [
              "https://amaanativf.com/",
              "https://amaanativf.com/about",
              "https://amaanativf.com/services",
              "https://amaanativf.com/contact",
              "https://amaanativf.com/bookappointment"
            ]
          })}
        </script>
      </Helmet>

      <div className="top-header">
        <div className="marquee-banner">
          <div className="marquee">
            <div className="marquee-content">
              🎉 Free IVF Consultation This Week | 20% Discount on First Cycle |
              Limited Seats Available | Call Now!
            </div>
          </div>
        </div>

        <nav className="navbar navbar-expand-lg bg-white shadow-sm" role="navigation">
          <div className="container">
            <Link
              className="navbar-brand d-flex align-items-center"
              to="/"
              title="Amaanat IVF Clinic Home"
              onClick={() => handleNavClick()}
            >
              <img
                src={logo}
                alt="Amaanat IVF Clinic Logo - Best IVF Centre in Ambala"
                className="navbar-brand-img"
                loading="eager"
              />
            </Link>

            <button
              className="navbar-toggler collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarMenu"
              aria-controls="navbarMenu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarMenu"
              ref={navbarRef}
            >
              <ul className="navbar-nav ms-auto align-items-lg-center">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive("/") ? "nav-link-active" : ""}`}
                    to="/"
                    title="Home - IVF Clinic in Ambala"
                    onClick={() => handleNavClick()}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item dropdown" ref={servicesRef}>
                  <a
                    className={`nav-link dropdown-toggle ${
                      isServicesActive() ? "fw-bold nav-link-active" : ""
                    }`}
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="true"
                    aria-expanded="false"
                    title="IVF and Fertility Services"
                    onClick={(e) => e.preventDefault()}
                  >
                    Services
                  </a>

                  <ul className="dropdown-menu dropdown-menu-custom">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/iui"
                        title="IUI Treatment in Ambala"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        IUI Treatment
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/ivf"
                        title="IVF Treatment in Ambala"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        IVF Treatment
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/icsi"
                        title="ICSI Treatment"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        ICSI
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/oocyte"
                        title="Oocyte Pickup Procedure"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        Oocyte Pickup
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/embryo"
                        title="Embryo Transfer IVF"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        Embryo Transfer
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/donor"
                        title="Egg Donor IVF Program"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        Egg Donor Program
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/gynae"
                        title="Gynaecology Services"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        Obstetrics & Gynae
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/services/pediatrics"
                        title="Pediatrics Care"
                        onClick={() => handleNavClick(servicesRef)}
                      >
                        Pediatrics
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item dropdown" ref={aboutRef}>
                  <a
                    className={`nav-link dropdown-toggle ${
                      isActive("/about") || isActive("/doctors")
                        ? "fw-bold nav-link-active"
                        : ""
                    }`}
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="true"
                    aria-expanded="false"
                    title="About Amaanat IVF"
                    onClick={(e) => e.preventDefault()}
                  >
                    About Us
                  </a>

                  <ul className="dropdown-menu dropdown-menu-custom">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/about"
                        title="Our Founders"
                        onClick={() => handleNavClick(aboutRef)}
                      >
                        Our Founders
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/doctors"
                        title="Our Experts"
                        onClick={() => handleNavClick(aboutRef)}
                      >
                        Our Experts
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive("/contact") ? "nav-link-active" : ""}`}
                    to="/contact"
                    title="Contact IVF Clinic in Ambala"
                    onClick={() => handleNavClick()}
                  >
                    Contact
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive("/career") ? "nav-link-active" : ""}`}
                    to="/career"
                    title="Careers at Amaanat IVF"
                    onClick={() => handleNavClick()}
                  >
                    Careers
                  </Link>
                </li>

                <li className="nav-item ms-lg-3">
                  <Link
                    to="/bookappointment"
                    className="btn btn-appointment"
                    title="Book IVF Appointment"
                    onClick={() => handleNavClick()}
                  >
                    Book Appointment
                  </Link>
                </li>

                <li className="nav-item ms-lg-3">
                  <a
                    className="btn btn-appointmentt"
                    href="tel:9991641100"
                    title="Call IVF Clinic"
                    onClick={() => handleNavClick()}
                  >
                    Call Us : 9991641100
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;